export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sys/article/queryBanner?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        queryDl(data) {
            data['bannerType']='denglu';
            return http.json({
                url: `/sys/article/queryBanner?pageNum=1&pageSize=99999`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/sys/article/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sys/article/saveBanner`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/sys/article/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/sys/article/delete`,
                data
            })
        },

        updateState(data) {
            return http.json({
                url: `/sys/article/updateState`,
                data
            })
        },
    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/banner.js